import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { App, Button, Descriptions, Divider, Drawer, Flex } from 'antd';
import React, { useState } from 'react';
import {
  getSalesInvoiceDetails,
  submitSalesInvoice,
} from '../../../network/salesInvoice';
import { queryKeys } from '../../../services/react-query/queryKeys';
import { getCountriesWithLanguages } from '../../../network/patients';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { useNavigate } from 'react-router-dom';
import { ModalAppPayment } from '../../upeosoft/ModalApp/ModalApp';
import { FaEdit } from 'react-icons/fa';

const DetailsInvoiceNumber = ({ open, setOpen, editId, t }) => {
  const client = useQueryClient();
  const [openPayment, setOpenPayment] = useState(false);
  const [editIdPayment, setEditIdPayment] = useState(null);
  const [totalPayment, setTotalPayment] = useState(0);
  const navigate = useNavigate();
  const { message } = App.useApp();
  const { currentLang } = useSelector((state) => state.user);
  const { mutate: onSubmitSalesInvoice } = useMutation({
    mutationKey: ['submitSalesInvoice'],
    mutationFn: (name) => submitSalesInvoice(name),
    onSuccess: (data) => {
      //  console.log(data, 'data');
      //  console.log(data?.message, 'data');
      //  console.log(data?.message?.status, 'data');
      if (data?.message?.status === 500) {
        message.error(data?.message?.message);
        return false;
      }
      data?.message?.message && message.success(data?.message?.message);
      client.invalidateQueries({
        queryKey: [queryKeys.getSalesInvoices],
      });
      setOpen(false);
    },
    onError: (error) => {
      message.error(error);
    },
  });

  const { data: salesInvoice, isLoading: loadingSales } = useQuery({
    queryKey: [queryKeys.getSalesInvoiceDetails, editId],
    queryFn: () => getSalesInvoiceDetails(editId),
    keepPreviousData: true,
    enabled: !!editId,
  });
  // const { data: countries } = useQuery({
  //   queryKey: [queryKeys.countriesWithLanguages, currentLang],
  //   queryFn: () => getCountriesWithLanguages(currentLang),
  //   keepPreviousData: true,
  // });
  const {
    patient,
    custom_patient_nationality,
    patient_name,
    ref_practitioner,
    custom_service_unit,
    service_unit,
    due_date,
    custom_payment_method,
    items = [],
    name,
    taxes = [],
    total_taxes_and_charges,
    grand_total,
    status,
    custom_encounter_no,
    base_grand_total,
  } = salesInvoice?.message?.message || {};
  // const country = countries?.message?.countries?.find(
  //   (item) => item?.name === custom_patient_nationality
  // );
  const itemsDescriptions = [
    {
      key: '1',
      label: t.patientFileNumber,
      children: patient,
    },
    {
      key: '2',
      label: t.patientName,
      children: patient_name,
    },
    // {
    //   key: '3',
    //   label: t.patientNationality,
    //   children: currentLang === 'en' ? country?.en : country?.ar,
    // },
    {
      key: '4',
      label: t.ReferringPractitioner,
      // span: 2,
      children: ref_practitioner,
    },
    {
      key: '5',
      label: t.serviceUnit,
      children: service_unit,
    },
    {
      key: '6',
      label: t.paymentDueDate,
      children: dayjs(due_date).format('YYYY-MM-DD'),
    },
    {
      key: '7',
      label: t.PaymentMethod,
      children: custom_payment_method,
    },
    // Items
    {
      key: '8',
      label: t.items,
      children: items[0]?.item_code,
    },
    {
      key: '9',
      label: t.quantity,
      children: items[0]?.qty,
    },
    {
      key: '10',
      label: t.discountAmount,
      children: items[0]?.discount_amount,
    },
    {
      key: '11',
      label: t.rate,
      children: items[0]?.rate,
    },
    {
      key: '12',
      label: t.amount,
      children: items[0]?.amount,
    },
    // TaxesandCharges
    {
      key: '12',
      label: t.type,
      children: taxes[0]?.charge_type,
    },
    {
      key: '13',
      label: t.AccountHead,
      children: taxes[0]?.account_head,
    },
    {
      key: '14',
      label: t.TaxRate,
      children: taxes[0]?.rate,
    },
    {
      key: '15',
      label: t.TaxAmount,
      children: taxes[0]?.tax_amount,
    },
    {
      key: '16',
      label: t.Total,
      children: taxes[0]?.total,
    },
    {
      key: '17',
      label: t.TotalTaxesandCharges,
      children: total_taxes_and_charges,
    },
    {
      key: '18',
      label: t.GrandTotal,
      children: grand_total,
    },
  ];
  return (
    <>
      <Drawer
        closable
        destroyOnClose
        title={<p>{t.InvoiceNumber + ': ' + name}</p>}
        placement={currentLang === 'en' ? 'right' : 'left'}
        extra={
          <Button
            // size="small"
            type="primary"
            ghost
            icon={<FaEdit />}
            // style={{ color: '#0958d9' }}
            onClick={() => navigate(`/sales-invoice/${name}`)}
          >
            {t.edit}
          </Button>
        }
        open={open}
        loading={loadingSales}
        onClose={() => setOpen(false)}
        width={900}
      >
        <Descriptions
          title={t.InvoiceDetails}
          layout="vertical"
          items={itemsDescriptions}
        />
        <Flex gap={10} style={{ marginTop: 10 }} justify="flex-end">
          {status === 'Draft' && (
            <Button
              // size="small"
              type="primary"
              style={{ backgroundColor: '#28a745' }}
              onClick={() => onSubmitSalesInvoice(name)}
            >
              {/* {t.SubmitSalesInvoice} */}
              {t.submit}
            </Button>
          )}
          {status === 'Draft' ||
            (status === 'Overdue' ? null : (
              <Button
                type="primary"
                onClick={() => navigate(`/payment-entry/sales/${name}`)}
              >
                {t.paymentEntry}
              </Button>
            ))}
          {status === 'Unpaid' && (
            <>
              <Button
                type="primary"
                onClick={() => {
                  setOpenPayment(true);
                  setEditIdPayment(name);
                  setTotalPayment(base_grand_total);
                }}
              >
                {t.Payment}
              </Button>
              <ModalAppPayment
                open={openPayment}
                setOpen={setOpenPayment}
                editId={editIdPayment}
                t={t}
                total={totalPayment}
              />
            </>
          )}
        </Flex>
      </Drawer>
    </>
  );
};

export default DetailsInvoiceNumber;
